




















import Vue from 'vue';

export default Vue.extend({
  name: 'MStoreButtons',
  props: {
    buttons: {
      type: Array,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  }
});
